<template>
  <el-dialog :title="isUpdate ? '编辑运营商' : '添加运营商'" :visible="visible" width="720px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-row :gutter="16">
        <el-col :sm="12">
          <el-form-item label="运营商名称:" prop="name">
            <el-input clearable v-model.trim="form.name" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="租户编码:" prop="code">
            <el-input clearable v-model.trim="form.code" placeholder="请输入" :disabled="isUpdate && form.id === 1" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="运营前端:" prop="admin_domain">
            <el-input clearable v-model.trim="form.admin_domain" placeholder="如 op-a.partner.com" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="商户前端:">
            <el-input clearable v-model.trim="form.merchant_domain" placeholder="如 m-a.partner.com" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="金主前端:">
            <el-input clearable v-model.trim="form.finance_domain" placeholder="如 f-a.partner.com" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="OpenAPI:" prop="api_domain">
            <el-input clearable v-model.trim="form.api_domain" placeholder="如 openapi-a.partner.com" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="落地前端:" prop="landing_domain">
            <el-input clearable v-model.trim="form.landing_domain" placeholder="支付落地页静态站，如 landing-a.partner.com（接口走 OpenAPI）" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="状态:" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="24">
          <el-form-item label="备注:">
            <el-input type="textarea" :rows="2" v-model.trim="form.remark" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'TenantEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: { status: 1 },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        admin_domain: [{ required: true, message: '请输入', trigger: 'blur' }],
        api_domain: [{ required: true, message: '请输入', trigger: 'blur' }],
        landing_domain: [{ required: true, message: '请输入', trigger: 'blur' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('enable_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({ status: 1 }, this.data);
        this.isUpdate = true;
      } else {
        this.form = { status: 1 };
        this.isUpdate = false;
      }
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading = true;
        this.$http.post('/tenant/edit', this.form).then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>
